import React, { useState } from 'react';

import Button from '../../../components/ui/Button';

const CodeBlock = ({ 
  code, 
  language = 'json', 
  title = '', 
  showCopy = true,
  className = '' 
}) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard?.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy code:', err);
    }
  };

  const formatCode = (code) => {
    if (language === 'json') {
      try {
        return JSON.stringify(JSON.parse(code), null, 2);
      } catch {
        return code;
      }
    }
    return code;
  };

  return (
    <div className={`bg-slate-900 rounded-lg overflow-hidden ${className}`}>
      {(title || showCopy) && (
        <div className="flex items-center justify-between px-4 py-2 bg-slate-800 border-b border-slate-700">
          <div className="flex items-center space-x-2">
            {title && (
              <span className="text-sm font-medium text-slate-200">{title}</span>
            )}
            <span className="text-xs text-slate-400 uppercase">{language}</span>
          </div>
          {showCopy && (
            <Button
              variant="ghost"
              size="xs"
              iconName={copied ? "Check" : "Copy"}
              onClick={copyToClipboard}
              className="text-slate-300 hover:text-white hover:bg-slate-700 h-6 px-2"
            />
          )}
        </div>
      )}
      <div className="p-4 overflow-x-auto">
        <pre className="text-sm text-slate-100">
          <code>{formatCode(code)}</code>
        </pre>
      </div>
    </div>
  );
};

export default CodeBlock;